import React, { Fragment, useEffect, useState } from 'react'
import { Row, Col, Button, Spinner } from 'reactstrap'
import TagsInput from '../../../../../ClinicHistory/ClinicEvent/components/TagsInput';
import ModalUI from '../../../../../../shared/components/Modal';
import IFacturaAppHTTP from '../../../../../ElectronicBilling/api/IFacturaAppHTTP';

const SendMailElectronicInvoice = ({ selectedInvoice, mailCostumer, setOpenModalSendMail }) => {
  const [mailToSend, setMailToSend] = useState([]);
  const [loadAction, setLoadAction] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [modalAlert, setModalAlert] = useState({ message: '', color: '', title: '' });

  const handleSelecetedTags = (items) => {
    setMailToSend(items)
  }

  const sendEmails = async () => {
    setLoadAction(true);
    let factura = {
      prefijo: selectedInvoice.num_fac_ter.split("-")[0],
      folio: selectedInvoice.num_fac_ter.split("-")[1],
      emails: mailToSend
    }

    await IFacturaAppHTTP.sendEmailsiFacturaApp(factura).then(response => {
      if (response.statuCode === 200) {
        setOpenAlert(true);
        setModalAlert({
          message: "Los correos se enviaron correctamente",
          color: 'success',
          title: "Éxito!"
        });
        setLoadAction(false);
      } else {
        setOpenAlert(true);
        setModalAlert({
          message: "Error al enviar los mensajes",
          color: 'danger',
          title: "Error!"
        });
        setLoadAction(false);
      }
    }).catch(err => {
      console.log(err)
      setOpenAlert(true);
      setModalAlert({
        message: "Error al enviar los mensajes",
        color: 'danger',
        title: "Error!"
      });
      setLoadAction(false);
    })
  }

  const onOkModal = () => {
    switch (modalAlert.color) {
      case "success":
        setOpenAlert(!openAlert);
        setOpenModalSendMail(false);
        break;
      case "danger":
        setOpenAlert(!openAlert);
        break;
    }
    setOpenAlert(!openAlert);
  }

  return (
    <Fragment>
      <div className="title-general">
        <h3>Enviar Correos</h3>
      </div>
      <Row className='row-default-space'>
        <Col md={12}>
          <TagsInput
            selectedTags={handleSelecetedTags}
            fullWidth
            variant="standard"
            id="tags"
            name="tags"
            placeholder="Agregar Correos"
            label="Correos a Enviar"
            InputLabelProps={{
              style: { color: '#646777' }
            }}
            emailValue={true}
            defaultTags={mailToSend}
            tags={mailCostumer}
          />
        </Col>
      </Row>
      <Row className='row-price-list-preview'>
        <div className='flex-end-elem-alg-center'>
          {loadAction &&
            <Spinner style={{ width: '24px', height: '24px', margin: '0em 1em' }} animation="border" variant="success" />
          }
          <div >
            <Button
              variant="contained"
              color="primary"
              disabled={!mailToSend.length || loadAction}
              size='sm'
              onClick={() => {
                sendEmails();
              }}
            >
              Enviar
            </Button>
          </div>
        </div>
      </Row>
      {openAlert &&
        <ModalUI
          color={modalAlert.color}
          title={modalAlert.title}
          message={modalAlert.message}
          modal={openAlert}
          toggle={() => { setOpenAlert(!openAlert) }}
          onOk={() => { onOkModal() }}
        />}
    </Fragment>
  )
}
export default SendMailElectronicInvoice